export default "__VITE_ASSET__CMkWQRpl__"